import React, { useState, useEffect, useRef } from "react";
import { Button, Tooltip, Zoom } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  clearAllDesktopNotifications,
  getActiveDesktopNotificationCount,
} from "../../widgets/phase-3/viewThreads/APIs/threadSocketHandler";

// Auto-hide button after this many milliseconds
const BUTTON_AUTO_HIDE_TIMEOUT = 8000; // 8 seconds

const DesktopNotificationClearButton = () => {
  // Temporarily hidden - will be implemented later
  return null;
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef(null);
  const wasVisibleRef = useRef(false);

  // Reset timeout
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      setCount(0);
      wasVisibleRef.current = false;
    }, BUTTON_AUTO_HIDE_TIMEOUT);
  };

  // Poll for notification count every second
  useEffect(() => {
    const updateCount = () => {
      const newCount = getActiveDesktopNotificationCount();

      // Show button when notifications appear (first time)
      if (newCount > 0 && !wasVisibleRef.current) {
        setVisible(true);
        wasVisibleRef.current = true;
        resetTimeout();
      }
      // If new notifications arrive while already visible, restart timeout
      else if (newCount > 0 && wasVisibleRef.current && newCount > count) {
        resetTimeout();
      }
      // Keep updating count while visible
      else if (newCount > 0) {
        setCount(newCount);
      }
      // Hide button when no notifications
      else if (newCount === 0 && wasVisibleRef.current) {
        setVisible(false);
        wasVisibleRef.current = false;
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      }

      setCount(newCount);
    };

    // Initial check
    updateCount();

    // Set up interval to check count
    const interval = setInterval(updateCount, 1000);

    return () => {
      clearInterval(interval);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [count]);

  // Don't render if not visible or no notifications
  if (!visible || count === 0) {
    return null;
  }

  const handleClear = () => {
    clearAllDesktopNotifications();
    setCount(0);
    setVisible(false);
    wasVisibleRef.current = false;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  return (
    <Tooltip
      title="Clear all desktop notifications"
      arrow
      TransitionComponent={Zoom}
    >
      <Button
        variant="contained"
        color="error"
        size="medium"
        onClick={handleClear}
        startIcon={<CloseIcon />}
        sx={{
          position: "fixed",
          top: 80,
          right: 24,
          zIndex: 9999,
          boxShadow: 3,
          "&:hover": {
            boxShadow: 6,
            transform: "translateY(-2px)",
          },
          transition: "all 0.2s ease",
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Clear desktop notifications
      </Button>
    </Tooltip>
  );
};

export default DesktopNotificationClearButton;
